import { LabelingTypeEnum } from 'src/types';

export const tagLabelOptions = [
  { label: 'Value', value: LabelingTypeEnum.VALUE },
  {
    label: 'Label',
    value: LabelingTypeEnum.LABEL,
  },
  { label: 'Value + Label', value: LabelingTypeEnum.VALUE_LABEL },
];
